import { Button, ButtonGroup, Grid } from "@mui/material";
import * as React from "react";
import apiCall from "../utils/apiCall";
import { GET_DASHBOARD } from "../endpoint";
import RequestsItem from "./RequestItem";
import RequestsHeader from "./RequestHeader";
import LoadingDashboard from "./LoadingDashboard";
import { useAppDispatch } from "../hooks/reduxhook";
import { addError } from "../redux/slices/errorSlice";

interface I_chat {
  answer: string;
  chat_id: string;
  chat_type: string;
  completion_token: string;
  cost: string;
  model: string;
  prompt_token: string;
  question: string;
  temp: string;
  timestamp: string;
  total_token: string;
  user_email: string;
}

interface i_requests {
  default: I_chat[];
  rag: I_chat[];
}

const Requests: React.FunctionComponent = () => {
  const [chats, setchats] = React.useState<i_requests>();
  const [rag, setrag] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const dispatch = useAppDispatch()
  React.useEffect(() => {
    setLoading(true);
    const getRequest = () => {
      apiCall("GET", GET_DASHBOARD)
        .then((res) => {
          setchats(res);
        })
        .catch((err) => {
          dispatch(addError("Failed to load the data for Dashboard.Please try again"))
        })
        .finally(() => setLoading(false));
    };
    getRequest();
  }, []);

  return (
    <Grid container my={2}>
      {loading ? (
        <LoadingDashboard />
      ) : (
        <>
          <ButtonGroup
            disableElevation
            variant="contained"
            aria-label="Disabled elevation buttons"
            sx={{
              margin: "auto",
              // float: "right",
            }}
            color="primary"
          >
            <Button
              variant={rag ? "contained" : "outlined"}
              onClick={() => setrag(true)}
            >
              RAG
            </Button>
            <Button
              variant={!rag ? "contained" : "outlined"}
              onClick={() => setrag(false)}
            >
              Default
            </Button>
          </ButtonGroup>
          <Grid container direction="column" my={2}>
            <RequestsHeader />
            {rag
              ? chats?.rag.map((item) => (
                <RequestsItem item={item} key={item.chat_id} />
              ))
              : chats?.default.map((item) => (
                <RequestsItem item={item} key={item.chat_id} />
              ))}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Requests;
